import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, SupplierData } from './types'

export const selectSupplierListEvent = (state: RootState): Event => state.supplierReducer.listEvent

export const selectSupplierList = (state: RootState): ListData => state.supplierReducer.list

export const selectSupplierActionEvent = (state: RootState): Event => state.supplierReducer.actionEvent

export const selectSupplierDetail = (state: RootState): SupplierData | undefined =>
  state.supplierReducer.detail

export const selectSupplierDetailEvent = (state: RootState): Event => state.supplierReducer.detailEvent

export const selectAllSupplierList = (state: RootState): SupplierData[] => state.supplierReducer.allSupplier
